import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function getOffersAPI(params?: typeof RestQueryParams): Observable<any> {
    const headers = undefined,
        queryParams = params ? params : new RestQueryParams();

    return jobHunterAPI.get(`api/offers/candidate_best_matched`, queryParams, headers);
}
